import { SubscriptionStatus } from '@brighterly/lib-core-types/subscription/enums'

import { safeLocalStorage } from '@shared/lib/browser'

import { useSubscriptionStore } from '../model/subscription-store/store'

export async function useStoreSubscriptionActions (getFailedSubscription: () => Promise<any>) {
  const subscriptionStore = useSubscriptionStore()
  const data = await getFailedSubscription()
  const status = data?.subscription?.status

  if (status === SubscriptionStatus.Failed) {
    subscriptionStore.setBannerPaymentRetry(true)
    subscriptionStore.setBannerPaymentRetryProcessing(false)
  } else if (status === SubscriptionStatus.Retrying) {
    const bannerPaymentRetryProcessing = safeLocalStorage.getItem('bannerPaymentRetryProcessing')
    const isStorageRetrying = bannerPaymentRetryProcessing === SubscriptionStatus.Retrying

    subscriptionStore.setBannerPaymentRetry(false)
    subscriptionStore.setRetryPaymentModal(false)

    subscriptionStore.setBannerPaymentRetryProcessing(true)

    if (!isStorageRetrying) {
      subscriptionStore.setModalRetryPaymentProcessing(true)
    }

    safeLocalStorage.setItem('bannerPaymentRetryProcessing', SubscriptionStatus.Retrying)
  } else {
    subscriptionStore.setBannerPaymentRetry(false)
    subscriptionStore.setRetryPaymentModal(false)

    subscriptionStore.setBannerPaymentRetryProcessing(false)
    subscriptionStore.setModalRetryPaymentProcessing(false)

    subscriptionStore.setModalPaymentRetrySuccess(false)

    subscriptionStore.setPaymentRetryData(null)

    safeLocalStorage.removeItem('bannerPaymentRetryProcessing')
  }
}
